export default __webpack_public_path__ + "static/Dune_JackieZhang-f01c12ec730c566f832fe53fd7e0100c.jpeg";